import React from 'react';
import FilterTag from './FilterTag';
import { Row, Col } from '@app/ui';
import { useParams } from 'react-router-dom';
import { BroadcastTab } from '../../../broadcasts/utils/broadcastsUtils';

type SelectedFiltersTagsProps = {
    selectedFiltersArray: {
        title: string;
        pluralTitle?: string;
        elements: string[];
        isHidden?: boolean;
        filterKey?: string;
    }[];
    overridingFiltersElement?: {
        title: string;
        elements: string[];
    }[];
};

const SelectedFiltersTags = ({
    selectedFiltersArray,
    overridingFiltersElement = [],
}: SelectedFiltersTagsProps) => {
    const { activeTab } = useParams();

    return (
        <Row
            gutter={16}
            style={{
                width: '100%',
            }}
        >
            <Col
                md={22}
                data-test="new-tag-container"
                className="-p-h-2"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    rowGap: '8px',
                }}
            >
                {overridingFiltersElement
                    .filter(
                        ({ title }) =>
                            activeTab !== BroadcastTab.VERBAL_MENTIONS ||
                            title !== 'Placements',
                    )
                    .map(({ title, elements = [] }, i) => {
                        if (elements.length !== 0)
                            return (
                                <FilterTag
                                    key={`overriding-${title}-${i}`}
                                    title={title}
                                    tagElements={elements}
                                    isOverriding
                                />
                            );
                    })}
                {selectedFiltersArray
                    .filter(
                        ({ filterKey }) =>
                            activeTab !== BroadcastTab.VERBAL_MENTIONS ||
                            filterKey !== 'placements',
                    )
                    .map(
                        (
                            { title, pluralTitle, elements = [], isHidden },
                            i,
                        ) => {
                            if (elements.length !== 0)
                                return (
                                    <FilterTag
                                        key={`${title}-${i}`}
                                        title={title}
                                        pluralTitle={pluralTitle}
                                        tagElements={elements}
                                        isHidden={isHidden}
                                    />
                                );
                        },
                    )}
            </Col>
        </Row>
    );
};

export default SelectedFiltersTags;
